const documentTypeConfigEvidenceList = {
  writ: {
    nameId: 'writ_id',
    documentType: 'writ',
  },
  promotion: {
    nameId: 'promotion_id',
    documentType: 'promotion',
  },
  demand: {
    nameId: 'demand_id',
    documentType: 'demand',
  },
  agreement: {
    nameId: 'agreement_id',
    documentType: 'agreement',
  },
  privateJudgment: {
    nameId: 'private_judgment_id',
    documentType: 'privateJudgment',
  },
  subpoena: {
    nameId: 'subpoena_id',
    documentType: 'subpoena',
  },
  recordAudience: {
    nameId: 'record_audience_id',
    documentType: 'recordAudience',
  },
  constancy: {
    nameId: 'constancy_id',
    documentType: 'constancy',
  },
  amparo: {
    nameId: 'amparo_id',
    documentType: 'amparo',
  },
  diligence: {
    nameId: 'diligence_id',
    documentType: 'diligence',
  },
  audience: {
    nameId: 'audience_id',
    documentType: 'audience',
  },
  convention: {
    nameId: 'convention_id',
    documentType: 'convention',
  },
  certification: {
    nameId: 'certification_id',
    documentType: 'certification',
  },
};

export default documentTypeConfigEvidenceList;
